import script from "./ConsumerCartView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerCartView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerCartView.vue?vue&type=style&index=0&id=058cde50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-058cde50"]])

export default __exports__